// Authentication service for handling login, logout, and auth state
import axios from 'axios';

const API_URL = '/api';

class AuthService {
  // Login user and store token
  async login(email, password) {
    try {
      const response = await axios.post('/api/auth/login', {
        email,
        password
      });
      
      if (response.data.data.token) {
        localStorage.setItem('auth_token', response.data.data.token);
        localStorage.setItem('user_info', JSON.stringify(response.data.data));
      }
      
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.error || { message: 'Login failed' };
    }
  }
  
  // Logout user and clear storage
  logout() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_info');
  }
  
  // Register new user
  async register(username, email, password) {
    try {
      const response = await axios.post('/api/auth/register', {
        username,
        email,
        password
      });
      
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || { message: 'Registration failed' };
    }
  }
  
  // Get current authenticated user
  getCurrentUser() {
    const userStr = localStorage.getItem('user_info');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch (e) {
      return null;
    }
  }
  
  // Check if user is authenticated
  isAuthenticated() {
    return !!localStorage.getItem('auth_token');
  }
  
  // Check if user is admin
  isAdmin() {
    const user = this.getCurrentUser();
    return user && user.role === 'admin';
  }
  
  // Get auth token
  getToken() {
    return localStorage.getItem('auth_token');
  }
  
  // Refresh user info from server
  async refreshUserInfo() {
    try {
      const response = await axios.get(API_URL + 'me', {
        headers: {
          Authorization: `Bearer ${this.getToken()}`
        }
      });
      
      localStorage.setItem('user_info', JSON.stringify(response.data.data));
      return response.data.data;
    } catch (error) {
      console.error('Failed to refresh user info:', error);
      return null;
    }
  }
}

export default new AuthService();
